import React from 'react';
import "./existingPatient.scss"

const ExistingPatient = ({setSearchKey,searchKey, patientSearch, setPatientSearch, Patients, handlePatientSelect }: any) => {
    
    return (
        <div>
            <div className="p-4 bg-white shadow-lg rounded-xl existing-patient">

                <div className="flex gap-2 mb-2">
                    <select
                        onChange={(e) => setSearchKey(e.target.value)}
                        value={searchKey}
                        className="flex-shrink-0 px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-white focus:outline-none"
                    >
                        <option value="patientId">Patient ID</option>
                        <option value="phone">Phone</option>
                        <option value="name">Name</option>
                    </select>
                    <input
                        className="flex-1 px-3 py-2.5 border border-gray-300 rounded-xl focus:outline-none text-sm"
                        type="text"
                        placeholder="Search..."
                        value={patientSearch}
                        onChange={(e) => setPatientSearch(e.target.value?.trim())}
                    />
                </div>
                {Patients?.length > 0 && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-2">
                        {Patients?.map((patient: any) => (
                            <div key={patient._id}
                                className="bg-white shadow-sm rounded-xl border border-primary p-4 flex flex-col gap-2">
                                <div className="flex items-center justify-between">
                                    <p className="font-bold text-gray-800 text-sm">{patient?.name}</p>
                                    <span className="text-xs text-gray-400">{patient?.patientId}</span>
                                </div>
                                <div className="grid grid-cols-2 gap-x-3 gap-y-1 text-xs text-gray-600">
                                    <div><span className="font-medium text-gray-400">Phone: </span>{patient?.phone}</div>
                                    <div><span className="font-medium text-gray-400">Gender: </span>{patient?.gender}</div>
                                    <div><span className="font-medium text-gray-400">Blood: </span>{patient?.bloodGroup}</div>
                                    <div><span className="font-medium text-gray-400">Marital: </span>{patient?.maritalStatus}</div>
                                </div>
                                <button
                                    className="mt-1 w-full py-2.5 bg-primary text-white rounded-lg text-sm font-semibold active:opacity-80"
                                    onClick={() => handlePatientSelect(patient)}
                                >
                                    Select Patient
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExistingPatient;